import { brandColorsFromService } from "./brand";
export const messagingFoundationFromService = (foundation) => ({
    primaryPitch: foundation.primary_pitch,
    ...("personality_description" in foundation && {
        personalityDescription: foundation.personality_description
    }),
    ctaExamples: foundation.cta_examples
});
export const channelExecutionFromService = (execution) => ({
    channel: execution.channel,
    ...("strategy" in execution && { strategy: execution.strategy }),
    headlines: execution.headlines,
    ...("descriptions" in execution && { descriptions: execution.descriptions }),
    ...("image_guidance" in execution && { imageGuidance: execution.image_guidance }),
    ...("size_briefs" in execution && { sizeBriefs: execution.size_briefs })
});
export const campaignDirectionFromService = (direction) => ({
    audienceSummary: direction.audience_summary,
    ...("cross_reference" in direction && { crossReference: direction.cross_reference }),
    ...("geo_summary" in direction && { geoSummary: direction.geo_summary }),
    ...("recommended_pillar" in direction && { recommendedPillar: direction.recommended_pillar }),
    ...("tone_guidance" in direction && { toneGuidance: direction.tone_guidance })
});
export const competitiveContextFromService = (context) => ({
    ...("positioning" in context && { positioning: context.positioning }),
    ...("adjacent_brands" in context && { adjacentBrands: context.adjacent_brands })
});
export const ctaStyleFromService = (style) => ({
    ...("background_color" in style && { backgroundColor: style.background_color }),
    ...("border_radius" in style && { borderRadius: style.border_radius }),
    ...("font_weight" in style && { fontWeight: style.font_weight }),
    ...("padding" in style && { padding: style.padding }),
    ...("text_color" in style && { textColor: style.text_color }),
    ...("text_transform" in style && { textTransform: style.text_transform })
});
export const brandFoundationFromService = (foundation) => ({
    ...("visual_identity" in foundation && { visualIdentity: foundation.visual_identity }),
    ...("imagery_style" in foundation && { imageryStyle: foundation.imagery_style }),
    ...(foundation.cta_style && { ctaStyle: ctaStyleFromService(foundation.cta_style) }),
    ...(foundation.color_palette && {
        colorPalette: brandColorsFromService(foundation.color_palette)
    }),
    ...("primary_logo_url" in foundation && { primaryLogoUrl: foundation.primary_logo_url })
});
export const creativeBriefFromService = (brief) => ({
    ...(brief.brand_foundation && {
        brandFoundation: brandFoundationFromService(brief.brand_foundation)
    }),
    ...(brief.messaging_foundation && {
        messagingFoundation: messagingFoundationFromService(brief.messaging_foundation)
    }),
    ...(brief.channel_executions && {
        channelExecutions: brief.channel_executions.map(channelExecutionFromService)
    }),
    ...(brief.campaign_direction && {
        campaignDirection: campaignDirectionFromService(brief.campaign_direction)
    }),
    ...(brief.competitive_context && {
        competitiveContext: competitiveContextFromService(brief.competitive_context)
    }),
    ...("compliance_notes" in brief && { complianceNotes: brief.compliance_notes })
});
//# sourceMappingURL=creative.js.map